exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".dispatch-info-tab{display:-ms-flexbox;display:flex;-ms-flex-flow:row;flex-flow:row}", "", {"version":3,"sources":["/home/runner/work/KeepNeyeVue/KeepNeyeVue/src/components/module/special-components/Modal-templates/ModificationDelivery-modal.vue"],"names":[],"mappings":"AACA,mBACE,oBAAqB,AACrB,aAAc,AACd,kBAAmB,AACf,aAAe,CACpB","file":"ModificationDelivery-modal.vue","sourcesContent":["\n.dispatch-info-tab {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row;\n      flex-flow: row;\n}\n"],"sourceRoot":""}]);

// exports
